<div class="add-user__wrapper">
  <seds-basic-button
    id="tour-1"
    class="add-user__button"
    (menuOpened)="iconName = 'expand_less'"
    (menuClosed)="iconName = 'expand_more'"
    [matMenuTriggerFor]="menu"
    title="Criar usuário"
    [iconName]="iconName"
    [iconPosition]="iconPositionRight"
  ></seds-basic-button>
</div>

<mat-menu class="add-user__menu" #menu="matMenu">
  <button 
    class="add-user__menu__item" 
    (click)="add()" 
  >
    A partir de acesso existente
  </button>
  <button
    class="add-user__menu__item"
    (click)="openCustomUserModal()"
    plAnalyticsButton 
    launchLabel="CriarLogonPersonalizado"
    launchSection="Clique"
    launchSiteSection="PortalDeLogons"
  >
    Solicitar acesso personalizado
  </button>
</mat-menu>
